import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { BsyUtils } from '../../utils/Utils'

import './index.css';

export default class BsyGroupList extends Component {

    static defaultProps = {
        hasMenu: true,
        hasDeletedList: true,
        hasAdd: true,
        hasCustom: true,

    }
    constructor(props) {
        super(props);
        this.state = {
            groupList: props.groups,
            hasCustom: props.hasCustom,
            nodeClicked: props.selectGroup,
            deletedNode: props.deletedNode,
            outsiderMemberRemove: props.outsiderMemberRemove,
            keyid: props.hasOwnProperty('keyid') ? props.keyid : '_id',
            sortable: props.hasOwnProperty('sortable') ? props.sortable : false,
            splitMenuIcon:'icon-outsdier-custom-group',
            splitMenuName: props.splitMenuName ? props.splitMenuName : React.language('outsider.custom.group'),
        }
        this.tableCont = React.createRef()
        this.onDragEnd = this.onDragEnd.bind(this);
    }


    onDragEnd(result) {
        this.tableCont.current.classList.remove('drag')
        if (!result.destination) {
            return;
        }
        this.onNodeSort(result);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

        if (!BsyUtils.compare(this.props.groups, nextProps.groups)) {
            const newtreeData = [...nextProps.groups]
            this.setState({
                groupList: newtreeData,
                nodeClicked: nextProps.selectGroup,
            })
        } else {
            this.setState({
                nodeClicked: nextProps.selectGroup,
            })
        }

    }

    onDragStart = (result) => {
        this.tableCont.current.classList.add('drag')
    }

    detailShow = (e) => {
        const { keyid } = this.state;
        if (this.props.nodeClick) {
            this.setState({ nodeClicked: e ? e[keyid] : null })
            this.props.nodeClick(e)
        }
    }

    onNodeSort = (result) => {
        if (this.props.nodeSort) {
            this.props.nodeSort(result)
        }
    }

    onMoreOperate = (e, node) => {
        if (this.props.nodeMoreOperate) {
            this.props.nodeMoreOperate(e, node)
        }
    }

    onAdd = () => {

        if (this.props.nodeAdd) {
            this.props.nodeAdd()
        }
    }

    render() {
        const { hasDeletedList, hasAdd, outsiderMemberRemove, customIcon, customOperate, hasMenu } = this.props;
        const { nodeClicked, deletedNode, keyid, sortable,splitMenuIcon,splitMenuName, hasCustom } = this.state;
        const groupList = [...this.state.groupList];
        let firstData = [];
        if (groupList.length && groupList[0].type == 1) {
            firstData = groupList.splice(0, 1);
        }


        return <div className='group-list' ref={this.tableCont} >

            {
                firstData.length ? <div className={'group-item default ' + (nodeClicked == firstData[0][keyid] ? 'select' : '')}
                    onClick={e => { this.detailShow(firstData[0]) }}
                ><i className={' title-icon ' + ( firstData[0].icon ? firstData[0].icon : 'icon-outsdier-defaut-group' )  } ></i><span title={firstData[0].name} >{firstData[0].name}</span><i onClick={e => { this.onMoreOperate(e, firstData[0]) }} className={'op icon-flow-other'} /></div>
                : ''
            }

            {hasCustom && <div className='group-item none' ><i className={'title-icon ' + splitMenuIcon } /><span >{splitMenuName}</span>
                {
                    hasAdd ? <i onClick={e => { this.onAdd() }} className={'op icon-add'} /> : ''
                }
            </div>}
            {groupList.length > 0 && <div className={"custom-groups " + (hasDeletedList ? 'has-deleted-list' : '')}>
                <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (

                            <div
                                {...provided.droppableProps}
                                // 为了使 droppable 能够正常工作必须 绑定到最高可能的DOM节点中provided.innerRef.
                                ref={sortable ? provided.innerRef : null}
                              
                            >

                                {groupList.map((item, index) => (
                                    item.status !== -99 &&
                                    <Draggable shouldRespectForcePress={true} key={item[keyid]} draggableId={item[keyid]} index={index}>
                                        {(provided, snapshot) => (
                                            <div className={'group-item ' + (nodeClicked == item[keyid] ? 'select' : '')}
                                                ref={provided.innerRef}

                                                {...provided.draggableProps}
                                                style={{
                                                    background: snapshot.isDragging ? "#fff" : "", // 拖动元素背景色
                                                    ...provided.draggableProps.style,
                                                  }}
                                                onClick={e => { this.detailShow(item) }}
                                            >
                                                {
                                                    customOperate && <i {...provided.dragHandleProps} className="icon-drag-table" />
                                                }
                                                {
                                                    !customIcon && item.icon && <i className={`item-icon ${item.icon}`}></i>
                                                }

                                                {
                                                    customIcon && customIcon(item)
                                                }

                                                <span title={item.customName || item.appname || item.name} style={{marginLeft: "6px"}} >{item.customName || item.appname || item.name}</span>
                                                {item.afterText && <span title={item.afterText} style={{color: item.afterTextColor, flex: 'none'}} >({item.afterText})</span>}
                                                {
                                                    sortable && !customOperate ? <i {...provided.dragHandleProps} className="icon-drag-table" /> : ''
                                                }
                                                {
                                                    customOperate && customOperate(item)
                                                }
                                                {
                                                    hasMenu ? <i onClick={e => { this.onMoreOperate(e, item) }} className={'op icon-flow-other'} /> : ''
                                                }
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {
                                    provided.placeholder
                                }
                            </div>

                        )}
                    </Droppable>
                </DragDropContext>
            </div>}
            {
                outsiderMemberRemove ? <div className={'group-item delete ' + (nodeClicked == deletedNode[0][keyid] ? 'select' : '')}
                    onClick={e => { this.detailShow(deletedNode[0]) }}
                ><i className={'title-icon icon-outsdier-deleted-group'} ></i><span title={deletedNode[0].name} >{deletedNode[0].name}</span></div> : ''
            }
        </div>
    }
}